import request from "@/config/utils/request";
// 铺货列表
export function getList(data) {
  return request({
    url: "/apis/demo/cc/queryApprovalList", // 后端接口
    method: "post",
    data
  });
}

// 获取所有省
export function getAllprovince(data) {
  return request({
    url: "/apis/demo/userAndEducation/listAddress",
    method: "POST",
    data
  });
}
